import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { string_type, list_type, equals } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FileImport$reflection } from "./Common.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";

export function loadFileImport(clientNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/FileImport/%i/"))(clientNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(FileImport$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(FileImport$reflection()), arg_1, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(FileImport$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

